import en from './en/app.json'
import routesEn from './en/routes.json'
import es from './es/app.json'
import routesEs from './es/routes.json'
import fr from './fr/app.json'
import routesFr from './fr/routes.json'
import it from './it/app.json'
import pl from './pl/app.json'
import pt from './pt/app.json'
import routesPt from './pt/routes.json'
/* oxlint-disable @typescript-eslint/no-unsafe-type-assertion */
import type { TMessages } from './translations.types'

export const locales = ['en', 'fr', 'es', 'pt', 'it', 'pl'] as const

export const defaultLocale = locales[0]

export const allMessages: Record<TLocale, TMessages> = {
  fr: { ...fr, ...routesFr },
  // Eslint warnings mean missing translations
  en: { ...en, ...routesEn } as Partial<TMessages> as TMessages,
  es: { ...es, ...routesEs } as Partial<TMessages> as TMessages,
  pt: { ...pt, ...routesPt } as Partial<TMessages> as TMessages,
  it: it as Partial<TMessages> as TMessages,
  pl: pl as Partial<TMessages> as TMessages,
}

export const defaultMessages = allMessages[defaultLocale]

export const unregisteredErrors = [
  '__comment.error.app',
  '__comment.error.backend',
  'admin.unauthorized',
  'anonymous.request',
  'birthdate.invalid',
  'captcha.invalid',
  'captcha.missing',
  'captcha.required',
  'comment.community.unknown',
  'comment.delete.fail.none',
  'comment.delete.not.found',
  'comment.form.empty',
  'comment.id.not-found',
  'comment.not-found',
  'comment.update.not.found',
  'common.form.error.captcha.invalid',
  'common.form.error.captcha.required',
  'common.form.error.message.required',
  'common.form.error.subject.required',
  'community.already-exists',
  'community.join.invalid-schedule-date',
  'community.join.not-schedulable',
  'community.leave.already.left',
  'community.leave.fail',
  'community.not-found',
  'community.not-joined',
  'community.unmodifiable',
  'communityAnnouncement.community.user.not-allowed',
  'communityAnnouncement.message.too-long',
  'communityAnnouncement.subject.too-long',
  'content.invalid',
  'content.invalid-contain-email',
  'content.invalid-contain-url',
  'content.required',
  'conversation.ambiguous-definition',
  'conversation.not-found',
  'conversation.user.not-allowed',
  'description.forbidden-content',
  'description.too-long',
  'description.too-short',
  'introduction.forbidden-content',
  'introduction.too-long',
  'introduction.too-short',
  'content.forbidden-content',
  'content.too-long',
  'content.too-short',
  'name.forbidden-content',
  'name.invalid',
  'name.too-long',
  'name.too-short',
  'dates.invalid',
  'description.invalid',
  'description.required',
  'device.delete.not.found',
  'draft.conflict',
  'email.already-exists',
  'email.user.not-found',
  'favorite.not-found',
  'file.not-an-image',
  'fromDate.in-the-past',
  'getCommunitiesJoined.user.not-found',
  'getCommunitiesWithRole.user.not-found',
  'getCommunityNotifications.subscriptionId.not-found',
  'guestName.required',
  'guestName.too-long',
  'guide.not-found',
  'hash.invalid',
  'hash.required',
  'intention.not-found',
  'intention.prayer.not-found',
  'intention.prayer.watchman.activate-notifications',
  'intention.prayer.watchman.method-reminder',
  'intention.prayer.watchman.reminder.by-email',
  'intention.prayer.watchman.reminder.by-notification',
  'intentions.not-found',
  'joinCommunity.community.join.already-finished-community',
  'lang.unsupported',
  'login.account.disabled',
  'login.account.missing',
  'login.code.required',
  'login.csrf.invalid',
  'login.email.invalid',
  'login.email.not-provided',
  'login.email.required',
  'login.failed',
  'login.password.required',
  'meeting.organizer.place.name-placeholder',
  'meeting.organizer.time-invalid',
  'meeting.organizer.timeStart-invalid',
  'message.delete.user.not_allowed',
  'message.invalid',
  'message.update.user.not_allowed',
  'name.exists',
  'name.required',
  'notificationEmail.invalid',
  'oldPassword.invalid',
  'page.gone',
  'page.not-found',
  'password.required',
  'password.too-long',
  'payload.bad-content',
  'payload.text-too-long',
  'pictureFileId.required',
  'postIntention.content.too-long',
  'prayerContent.invalid',
  'prayerContent.too-long',
  'prayerName.invalid',
  'prayerName.required',
  'prayerName.too-long',
  'prayerSample.not-found',
  'publication.already-exists',
  'publicationFrequencyType.required',
  'publicationFrequencyValue.invalid',
  'publicationFrequencyValue.required',
  'reportAbuse.reason.required',
  'reportAbuse.type.invalid',
  'resetPassword.token.invalid',
  'role.invalid',
  'scheduledTime.invalid',
  'sendMessage.payload.bad-content',
  'signup.captcha.required',
  'signup.code.invalid',
  'signup.email.invalid',
  'signup.email.exists',
  'signup.email.required',
  'signup.fail',
  'signup.name.invalid',
  'signup.name.required',
  'signup.password.required',
  'startConversation.payload.bad-content',
  'startConversation.user.not-found',
  'tag.not-found',
  'token.expired',
  'token.required',
  'user.not-found',
  'user.settings.tab.account.password-required',
  'widget.not-found',
  'wizard.communityFormats.unknown',
  'wizard.communityTypes.unknown',
  'wizard.prayerDuration.unknown',
  'wizard.tags.unknown',
]
